import { computed } from 'vue'
import { toHours } from 'give-a-day-shared/utils/date.mjs'
import { isSet } from 'give-a-day-shared/utils/isSet.mjs'

// Make sure this is kept in-sync with what is defined in the searchOneDayVacancies.mjs file
export function useTimings (startTime, endTime) {
  const nuxtApp = useNuxtApp()

  const timingText = computed(() => {
    if (isSet(startTime.value) && isSet(endTime.value)) {
      const start = toHours(startTime.value)
      const end = toHours(endTime.value)
      const diffHours = end - start

      if (diffHours >= 6) {
        return nuxtApp.$gadTranslateUpper('general_full_day')
      }

      // Define time blocks in hours
      const MORNING = [6, 12]
      const AFTERNOON = [12, 17]
      const EVENING = [17, 22]

      // Helper to detect overlap
      const overlaps = (rangeStart, rangeEnd) => start < rangeEnd && end > rangeStart

      if (overlaps(...MORNING)) {
        return nuxtApp.$gadTranslateUpper('general_morning')
      }
      if (overlaps(...AFTERNOON)) {
        return nuxtApp.$gadTranslateUpper('general_afternoon')
      }
      if (overlaps(...EVENING)) {
        return nuxtApp.$gadTranslateUpper('general_evening')
      }

      return nuxtApp.$gadTranslateUpper('general_night')
    }
    return null
  })

  return { timingText }
}
